module.exports = __webpack_public_path__ + "img/20200201_160818.fb196a7b.jpg";